export default __webpack_public_path__ + "static/media/INEFOP_azul.259341ff.png";